<!-- 由 woniu6162 创建于 2021-03-19 星期五 -->
<template>
  <div class="pop">
    <van-popup
      v-model="datum.show"
      position="bottom"
      round
      get-container="#app"
    >
      <van-picker
        show-toolbar
        :columns="datum.list"
        @confirm="confirm"
        @cancel="cancel"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'pop',

  mixins: [],

  components: {},

  props: {
    datum: {
      type: Object,
      required: true
    }
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    confirm(obj) {
      this.$emit('yes', obj)
    },
    cancel() {
      this.datum.show = false
      this.$emit('no')
    }
  }
}
</script>

<style lang="scss" scoped>
.pop {
}
</style>
